import BaseCrudService from "./baseCrud.service";

export default class ApiPartnerService extends BaseCrudService {
    constructor() {
        super('ApiPartner');
    }

    listAll() {
        return this.getRequest('ListAll');
    }

    createWithKey(model) {
        return this.postRequest('CreateWithKey', model);
    }

    listCampaigns() {
        return this.getRequest('ListCampaignsSimple');
    }
    listCompanies() {
        return this.getRequest('ListCompaniesSimple');
    }
    listCampaignsByCompany(companyId) {
        return this.getRequest('ListCampaignsByCompany', { companyId });
    }
    permissionCatalog() {
        return this.getRequest('PermissionCatalog');
    }

    updatePartner(model) {
        return this.putRequest('UpdatePartner', model);
    }

    toggleActive(id) {
        return this.putRequest('ToggleActive', { id: id });
    }

    // Webhook methods
    listWebhooks(apiPartnerId) {
        return this.getRequest('ListWebhooks', { apiPartnerId });
    }

    createWebhook(model) {
        return this.postRequest('CreateWebhook', model);
    }

    updateWebhook(model) {
        return this.putRequest('UpdateWebhook', model);
    }

    toggleWebhookActive(id) {
        return this.putRequest('ToggleWebhookActive', { id });
    }

    deleteWebhook(id) {
        return this.deleteRequest('DeleteWebhook', { id });
    }
}
